import React  from 'react';
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import MyMapComponent from "./MyMapComponent";


/*
  The basic usage of this component (Wrapper)
  is to wrap child components that depend on Maps JavaScript API.
  The Wrapper component also accepts
  a render prop for rendering loading components
  or handling errors in loading the Maps JavaScript API.
*/
const API_KEY = "AIzaSyD62F-_xI5u46TrNiNhmJ4Rblt-tvNEEKs"

const render = (status) => {
  if (status === Status.LOADING) return "Loading...";
  if (status === Status.FAILURE) return "Error";
  return null;
};

const MapWrapper = () => {
  return (
    <Wrapper apiKey={API_KEY} render={render}>
      <MyMapComponent />
    </Wrapper>
  );
};

export default MapWrapper;

/*  <Wrapper apiKey="AIzaSyD62F-_xI5u46TrNiNhmJ4Rblt-tvNEEKs" render={render}>
<MyMapComponent />
</Wrapper>
return null;*/